import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, useTheme } from "@mui/material";

import { useAppNavigate } from "Infrastructure/Routing/useAppNavigate";

interface EntityLinkProps {
  label: string;
  path: string;
  newTab?: boolean;
}

export const EntityLink = ({
  label,
  path,
  newTab = true,
}: EntityLinkProps): React.ReactNode => {
  const theme = useTheme();
  const navigate = useAppNavigate();

  const sx = {
    color: theme.palette.primary.main,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    "&:hover": { textDecoration: "underline" },
  };

  if (newTab) {
    return (
      <Box
        component="a"
        href={path}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ ...sx, textDecoration: "none" }}
      >
        {label}
        <OpenInNewIcon sx={{ fontSize: 13, ml: 0.5 }} />
      </Box>
    );
  }

  return (
    <Box sx={sx} onClick={() => navigate(path)}>
      {label}
    </Box>
  );
};
